import React from 'react';
import {Field} from 'redux-form';
import SignatureReduxFormComponent from "./ReduxFormComponent/Signature";

const Signature = props => <Field {...props} component={SignatureReduxFormComponent}/>;

export default Signature;